module.exports = __webpack_public_path__ + "static/img/yswz1.9187a27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/yswz1.png
// module id = pksz
// module chunks = 59